import script from "./InviaOrdine.vue?vue&type=script&setup=true&lang=js"
export * from "./InviaOrdine.vue?vue&type=script&setup=true&lang=js"

import "./InviaOrdine.vue?vue&type=style&index=0&id=3a66a5a0&lang=scss&scoped=true"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a66a5a0"]])

export default __exports__